// extracted by LIB_CSS_EXTRACT_LOADER
import "./copy-button_module.css"
export default {"copyButton":"copyButton-X1xcdJ","icon":"icon-X6pnOm"};